import { useState } from 'react'
import { useSubscription } from '../contexts/SubscriptionContext.jsx'
import { stripeService } from '../services/stripe.js'
import { useToast } from '../contexts/ToastContext.jsx';

/**
 * App-wide banner shown when a subscriber's payment has failed (Stripe sets the
 * subscription status to `past_due` during dunning, which our webhook persists).
 * Nudges them to update their card via the Stripe billing portal before Stripe's
 * retries run out and the subscription is canceled (which downgrades them to Free).
 */
function PaymentFailedBanner() {
  const { subscriptionData } = useSubscription()
  const { showToast } = useToast();
  const [isOpening, setIsOpening] = useState(false)

  if (subscriptionData?.status !== 'past_due') return null

  const handleUpdatePayment = async () => {
    setIsOpening(true)
    try {
      const res = await stripeService.createPortalSession(window.location.href)
      if (res?.url) {
        window.location.href = res.url
      } else {
        throw new Error('No portal URL')
      }
    } catch (err) {
      console.error('Could not open billing portal:', err)
      showToast('Could not open the billing portal. Please try again.', 'error')
      setIsOpening(false)
    }
  }

  return (
    <div className="app-top-banner" style={styles.banner} role="alert">
      <span style={styles.text}>
        Your last payment didn’t go through. Update your payment method to keep your Pro access
        otherwise your plan will drop to Free.
      </span>
      <button style={styles.button} onClick={handleUpdatePayment} disabled={isOpening}>
        {isOpening ? 'Opening…' : 'Update payment method'}
      </button>
    </div>
  )
}

const FONT = "'Red Hat Display', 'Inter', sans-serif"

const styles = {
  banner: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '14px',
    padding: '12px 20px',
    background: '#FEF3F0',
    borderBottom: '1px solid rgba(239, 105, 57, 0.3)',
    color: '#1A1A1A',
    fontFamily: FONT,
    fontSize: '15px',
    lineHeight: 1.4,
    textAlign: 'center',
  },
  text: { fontWeight: 500, fontFamily: FONT },
  button: {
    flexShrink: 0,
    border: 'none',
    borderRadius: '999px',
    background: '#EF6939',
    color: '#ffffff',
    fontFamily: FONT,
    fontWeight: 600,
    fontSize: '14px',
    padding: '9px 18px',
    cursor: 'pointer',
  },
}

export default PaymentFailedBanner
